import type { TFunction } from "i18next";

/**
 * メッセージの表示テキストを解決する共通ロジック。
 * メッセージ一覧・メッセージ詳細・アプリ内通知の3箇所で使用する。
 */
export function resolveMessagePreview(
  content: string | null,
  msgType: string | undefined,
  isOwn: boolean,
  t: TFunction,
): string {
  if (content === null) return "";
  if (content === "キャンセル" || content === "Cancel") {
    return isOwn ? t("chat.room.callCancelled") : t("chat.room.missedCall");
  }
  if (msgType === "EVIDEO") return "";
  if (msgType === "STK") {
    return isOwn ? t("chat.list.stickerSent") : t("chat.list.stickerReceived");
  }
  if (msgType === "ABSENCECALL") {
    if (content.includes("|")) return t("chat.room.callEnded");
    return isOwn ? t("chat.room.callCancelled") : t("chat.room.missedCall");
  }
  if (content.includes("|p|")) {
    return isOwn ? t("chat.list.imageSent") : t("chat.list.imageReceived");
  }
  if (content.includes("|v|")) {
    return isOwn ? t("chat.list.videoSent") : t("chat.list.videoReceived");
  }
  if (content.includes("|a|")) {
    return isOwn ? t("chat.list.audioSent") : t("chat.list.audioReceived");
  }
  return content;
}
